/* eslint-disable react/prop-types */
/* eslint-disable react/no-array-index-key */
import React, { useMemo, useCallback } from 'react';
import { DragDropContext, Droppable, Draggable } from '@hello-pangea/dnd';
import { QUESTION_VALUE_TYPE } from '../../../../constants/common';
import LabelItem from './LabelItem';

const LabelList = ({
  sample,
  labels,
  onLabelChange,
  onLabelIdOrderChange,
  onDirty,
  labelIdOrders,
}) => {
  // Derived during render rather than mirrored into state, for the same reason
  // as AnswerList: a lagged copy makes React rewrite the input with the
  // previous string and the caret jumps to the end on every keystroke.
  const labelList = useMemo(() => {
    const labelMaps = {};
    (labels || []).forEach((label) => {
      labelMaps[label.id] = label.value;
    });
    return labelMaps;
  }, [labels]);

  const moveCard = useCallback(
    (result) => {
      if (!result.destination) {
        return;
      }
      const list = [...labelIdOrders];
      const [removedItem] = list.splice(result.source.index, 1);
      list.splice(result.destination.index, 0, removedItem);
      onLabelIdOrderChange(list);
      onDirty();
    },
    [labelIdOrders, onLabelIdOrderChange, onDirty]
  );

  return (
    <>
      {[QUESTION_VALUE_TYPE.MULTIPLE, QUESTION_VALUE_TYPE.GRID].includes(sample?.Data.valueType) &&
        labels.length > 0 && (
          <div>
            <h4>Labels</h4>
            <DragDropContext onDragEnd={moveCard}>
              <Droppable droppableId="droppable">
                {(provided) => (
                  <div ref={provided.innerRef} {...provided.droppableProps}>
                    {labelIdOrders.map((id, index) => {
                      return (
                        <Draggable
                          key={index}
                          draggableId={`draggable-report-item-${index}`}
                          index={index}
                        >
                          {(draggableProvided) => (
                            <LabelItem
                              draggableProvided={draggableProvided}
                              key={index}
                              label={{ id, value: labelList[id] }}
                              index={index}
                              onLabelChange={onLabelChange}
                              onDirty={onDirty}
                            />
                          )}
                        </Draggable>
                      );
                    })}
                    {provided.placeholder}
                  </div>
                )}
              </Droppable>
            </DragDropContext>
          </div>
        )}
    </>
  );
};

export default LabelList;
